import { SERVICE_DOCUMENT_URL } from './constants'
import styles from './styles.module.scss'

const ServiceDocumentSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.documents}`} id="docs">
    <div className={`${styles.content} ${styles.documentsShell}`}>
      <div>
        <span className={`${styles.eyebrow} ${styles.reveal}`} data-reveal="">
          サービス資料
        </span>
        <h2 className={styles.reveal} data-reveal="">
          店舗オーナーに渡せる、サービス資料をご用意しています
        </h2>
        <p className={styles.reveal} data-reveal="">
          「知り合いのお店に話してみたいけれど、どう説明すればいいかわからない」という方へ。店舗・施設向けに
          ecbo cloak
          の仕組みと導入メリットをまとめたサービス資料です。そのままオーナーへ共有いただけます。
        </p>
        <div className={`${styles.documentItem} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/document_icon.svg" alt="" />
          <div>
            <b>ecbo cloak サービス紹介資料</b>
            <span>サービスの仕組み、利用者の声、店舗のメリット</span>
          </div>
        </div>
      </div>
      <div className={`${styles.documentsCard} ${styles.reveal}`} data-reveal="">
        <h3>サービス資料を受け取る</h3>
        <p>フォームにご入力のあと、店舗・施設向けのサービス資料をお受け取りいただけます。</p>
        <a
          href={SERVICE_DOCUMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.button} ${styles.ghostButton}`}
        >
          サービス資料を受け取る
        </a>
        <small>所要1分・無料</small>
      </div>
    </div>
  </section>
)

export default ServiceDocumentSection
